__turbopack_context__.v({
  "h1": "PlasmicTerms-module__YQ-f0G__h1",
  "h2__bm1M5": "PlasmicTerms-module__YQ-f0G__h2__bm1M5",
  "h2__hVg5L": "PlasmicTerms-module__YQ-f0G__h2__hVg5L",
  "h2__nCcm6": "PlasmicTerms-module__YQ-f0G__h2__nCcm6",
  "h2__us4Vy": "PlasmicTerms-module__YQ-f0G__h2__us4Vy",
  "li___6ScyD": "PlasmicTerms-module__YQ-f0G__li___6ScyD",
  "li___7Izkh": "PlasmicTerms-module__YQ-f0G__li___7Izkh",
  "li__m8H7": "PlasmicTerms-module__YQ-f0G__li__m8H7",
  "li__qxfOc": "PlasmicTerms-module__YQ-f0G__li__qxfOc",
  "li__thXoJ": "PlasmicTerms-module__YQ-f0G__li__thXoJ",
  "ol___13JM6": "PlasmicTerms-module__YQ-f0G__ol___13JM6",
  "ol__dKhPo": "PlasmicTerms-module__YQ-f0G__ol__dKhPo",
  "ol__irCXu": "PlasmicTerms-module__YQ-f0G__ol__irCXu",
  "ol__qzme5": "PlasmicTerms-module__YQ-f0G__ol__qzme5",
  "ol__uWsK": "PlasmicTerms-module__YQ-f0G__ol__uWsK",
  "ol__vUxvx": "PlasmicTerms-module__YQ-f0G__ol__vUxvx",
  "ol__xbp5U": "PlasmicTerms-module__YQ-f0G__ol__xbp5U",
  "primaryButton": "PlasmicTerms-module__YQ-f0G__primaryButton",
  "root": "PlasmicTerms-module__YQ-f0G__root",
  "svg__gHpW": "PlasmicTerms-module__YQ-f0G__svg__gHpW",
  "svg__gvPi7": "PlasmicTerms-module__YQ-f0G__svg__gvPi7",
  "text___9Cxst": "PlasmicTerms-module__YQ-f0G__text___9Cxst",
  "text__kkQdt": "PlasmicTerms-module__YQ-f0G__text__kkQdt",
});
